<template>
  <div class="popularActivities">
    <div class="banner"></div>
    <div class="content">
      <ul class="datalist-show" v-if="dataList.length > 0">
        <li v-for="(item, index) in dataList" :key="index">
          <div class="box">
            <img :src="item.imgs" alt="" class="bgimg" />
          </div>
          <div class="mask">
            <div class="line"></div>
            <div class="name-title">{{ item.title }}</div>
            <div class="line"></div>
          </div>
          <div class="bom">
            <p class="p-bom">{{ item.title }}</p>
            <p class="p-bom2">{{ item.info }}</p>
            <p class="p-bom3">
              <span class="spm1">查看详情</span>
              <img
              src="http://dfs.yun300.cn/group1/M00/16/BE/rBQBG1zeRF-EZ6WeAAAAALtrhrs312.png"
                alt=""
                class="white-icon"
              />
              <img src="http://dfs.yun300.cn/group1/M00/04/E8/rBQBHVzeREuEL1FvAAAAAB_7d88582.png" alt="" class="black-icon"> 
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
        
<script>
export default {
  data() {
    return {
      dataList: [
        {
          id: "houjiahui001",
          imgs: "http://img601.yun300.cn/repository/image/0572a534-206c-4018-be17-ae649b8db3ac.jpg?tenantId=214689&viewType=1&k=1651226704000",
          title: "阿里钉钉郑州首场LCDP训练营，圆满落幕！",
          info: "低代码LCDP训练营郑州站",
        },
        {
          id: "houjiahui002",
          imgs: "http://img601.yun300.cn/repository/image/6391ba42-4ed5-46a0-8ced-681777f557aa.jpg?tenantId=214689&viewType=1&k=1651226704000",
          title: "低代码LCDP训练营第45期-合肥站完美收官！",
          info: "低代码LCDP训练营合肥站第45期",
        },
        {
          id: "houjiahui003",
          imgs: "http://img601.yun300.cn/repository/image/2a3cb6f7-a6f1-4f10-a27c-f482e79dbb66.png?tenantId=214689&viewType=1&k=1651226704000",
          title: "2021“专精特新”企业数字化转型高峰论坛",
          info: "20211222期",
        },
        {
          id: "houjiahui004",
          imgs: "http://img601.yun300.cn/repository/image/aa579899-a4ff-4ee0-8d5e-bb9fd9709b41.png?tenantId=214689&viewType=1&k=1651226704000",
          title: "第七期【低代码 LCDP 训练营】-合肥站即将开营!",
          info: "低代码LCDP训练营-合肥站第七期",
        },
        {
          id: "houjiahui005",
          imgs: "http://img601.yun300.cn/repository/image/4d185981-9e06-4bc1-be9a-b0bd6dc17ccf.jpg?tenantId=214689&viewType=1&k=1651226704000",
          title: "2021阿里钉钉企业数字化管理峰会",
          info: "20211119期",
        },
        {
          id: "houjiahui006",
          imgs: "http://img601.yun300.cn/repository/image/15985b7f-eabe-4e6f-9f0c-ef8089513d8a.jpg?tenantId=214689&viewType=1&k=1651226704000",
          title: "阿里钉钉数字化管理峰会",
          info: "20210624期",
        },

        {
          id: "houjiahui007",
          imgs: "http://img601.yun300.cn/repository/image/9ff5aaf8-35ab-497f-8c17-1d2234dc94c4.jpg?tenantId=214689&viewType=1&k=1651226704000",
          title: "钉钉让天下没有难带的团队",
          info: "20210416期",
        },
        {
          id: "houjiahui008",
          imgs: "http://img601.yun300.cn/repository/image/73dec5e7-3840-47f5-93b1-6860d75f1e41.jpg?tenantId=214689&viewType=1&k=1651226704000",
          title: "阿里钉钉数字工厂交流会",
          info: "20201222期",
        },
        {
          id: "houjiahui009",
          imgs: "http://img601.yun300.cn/repository/image/1bd77201-4868-474f-b31b-804b9389c706.jpg?tenantId=214689&viewType=1&k=1651226704000",
          title: "阿里钉钉工程项目数字化管理交流会",
          info: "20201210期",
        },
      ],
    };
  },
};
</script>
<style lang='less' scoped>
.popularActivities {
  width: 100%;
  text-align: left;
  .banner {
    width: 100%;
    height: 262px;
    background-image: url("http://img601.yun300.cn/repository/image/cba1ee03-8c80-4bd8-a9cb-9be267766176.jpg?tenantId=214689&viewType=1&k=1651226704000");
    background-size: 100%;
    background-repeat: no-repeat;
  }
}
.content {
  width: 66%;
  margin: 0 auto;
  margin-bottom: 30px;
  > .datalist-show {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 60px;
    // justify-content: space-around;
    li {
      width: 373px;
      height: 393px;
      position: relative;
      cursor: pointer;
      margin-bottom: 20px;
      margin-left: 40px;
      .box {
        width: 373px;
        overflow: hidden;
        height: 225px;
        img {
          width: 100%;
          transition: all 0.3s linear;
          height: 100%;
        }
      }
      .mask {
        width: 373px;
        height: 225px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: all 0.5s linear;
        .line {
          width: 150px;
          height: 1px;
          background-color: #fff;
          transition: all 0.5s linear;
        }
        .name-title {
          margin-top: 9px;
          margin-bottom: 9px;
          color: #fff;
          font-size: 16px;
          line-height: 16px;
        }
      }
      .bom {
        width: 100%;
        height: 132px;
        padding: 15px 20px 10px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        text-align: left;
        .p-bom {
          line-height: 23px;
          text-align: left;
          color: #000;
          font-size: 16px;
          // 不换行超出显示。。。
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .p-bom2 {
          line-height: 20px;
          text-align: left;
          color: #777;
          font-size: 14px;
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          word-break: break-all;
          margin-top: 8px;
          margin-bottom: 10px;
        }
        .p-bom3 {
          width: 100%;
          border-top: 1px solid #eee;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 24px;
            height: 8px;
            margin-right: 20px;
            background-image: url();
          }
          >.white-icon{
              display: block;
          }
          >.black-icon{
              display: none;
          }
          &:hover {
            .black-icon{
                display: block;
            }
            .white-icon{
                display: none;
            }
          }
          .spm1 {
            margin-left: 20px;
            color: #777;
            font-size: 14px;
          }
        }
      }
    }
    li:hover .mask {
      opacity: 1;
    }
    li:hover .line {
      width: 20px;
    }
    li:hover .bgimg {
      transform: scale(1.1);
    }
  }
}
</style>